// Local storage service for managing application data
class StorageService {
  // Keys for localStorage
  static KEYS = {
    ORGANIZATION_ID: 'dental_app_organization_id',
    USER_PREFERENCES: 'dental_app_user_preferences'
  };

  // Organization ID management
  static setOrganizationId(organizationId) {
    try {
      if (organizationId) {
        localStorage.setItem(this.KEYS.ORGANIZATION_ID, organizationId);
      }
    } catch (error) {
      console.error('Error saving organization ID to localStorage:', error);
    }
  }

  static getOrganizationId() {
    try {
      return localStorage.getItem(this.KEYS.ORGANIZATION_ID);
    } catch (error) {
      console.error('Error reading organization ID from localStorage:', error);
      return null;
    }
  }

  static removeOrganizationId() {
    try {
      localStorage.removeItem(this.KEYS.ORGANIZATION_ID);
    } catch (error) {
      console.error('Error removing organization ID from localStorage:', error);
    }
  }

  // User preferences management
  static setUserPreferences(preferences) {
    try {
      localStorage.setItem(this.KEYS.USER_PREFERENCES, JSON.stringify(preferences));
    } catch (error) {
      console.error('Error saving user preferences to localStorage:', error);
    }
  }

  static getUserPreferences() {
    try {
      const preferences = localStorage.getItem(this.KEYS.USER_PREFERENCES);
      return preferences ? JSON.parse(preferences) : null;
    } catch (error) {
      console.error('Error reading user preferences from localStorage:', error);
      return null;
    }
  }

  static removeUserPreferences() {
    try {
      localStorage.removeItem(this.KEYS.USER_PREFERENCES);
    } catch (error) {
      console.error('Error removing user preferences from localStorage:', error);
    }
  }

  // Clear all app data (useful for logout)
  static clearAllData() {
    try {
      Object.values(this.KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
    } catch (error) {
      console.error('Error clearing localStorage data:', error);
    }
  }

  // Check if localStorage is available
  static isAvailable() {
    try {
      const test = '__localStorage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }
}

export default StorageService;
